
import Cropper from 'utils/cropperjs';
import './index.erb';
import './index.rb';

export default class CropImageModal {
  constructor(imageContent, saveCallback, cancelCallback) {
    this.imageContent = imageContent;
    this.saveCallback = saveCallback;
    this.cancelCallback = cancelCallback;
    this.$cropModal = $('#js-crop-modal');
    this.$cropImg = $('#js-crop-image', this.$cropModal);
    this.saveBtn = $('#js-save-image-crop', this.$cropModal)[0];
    this.cancelBtn = $('#js-cancel-image-crop', this.$cropModal)[0];
    this.bind();
  }

  async show() {
    this.$cropImg.attr('src', this.imageContent);
    this.$cropModal.modal({ backdrop: 'static', keyboard: false });
  }

  async setCropper() {
    try {
      this.cropper = await new Cropper(this.$cropImg[0]);
    } catch (ex) {
      toastr.error('Tivemos um problema ao tentar enviar sua foto!');
      Rollbar.error('Could not load Cropper js', ex);
    }
  }

  saveImage() {
    const canvas = this.cropper.getCroppedCanvas({
      width: 196,
      height: 196
    });
    canvas.toBlob((blob) => this.saveCallback(blob, canvas.toDataURL()));
    this.$cropModal.modal('hide');
  }

  bind() {
    this.$cropModal.on('shown.bs.modal', () => {
      this.setCropper();
    }).on('hidden.bs.modal', () => {
      this.cropper.destroy();
    });

    this.saveBtn.onclick = () => {
      this.saveImage();
    };

    this.cancelBtn.onclick = () => {
      if (this.cancelCallback) {
        this.cancelCallback();
      }
    };
  }
}
